import { Injectable, Injector } from '@angular/core';
import { DatasourceTableGitFactoryService } from '@y42/datasource';
import { UiModelingTableGitService } from './ui-modeling-table-git.service';

@Injectable({ providedIn: 'root' })
export class UiModelingTableGitFactoryService extends DatasourceTableGitFactoryService<UiModelingTableGitService> {
  constructor(injector: Injector) {
    super({
      injector,
      gitService: UiModelingTableGitService,
    });
  }
}
